class DetailsDisclosure extends HTMLElement {
	constructor() {
		super();
		this.mainDetailsToggle = this.querySelector("details");

		this.addEventListener("keyup", this.onKeyUp);
		document.addEventListener("click", this.onFocusOut.bind(this));
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;

		const openDetailsElement = event.target.closest("details[open]");
		if (!openDetailsElement) return;

		const summaryElement = openDetailsElement.querySelector("summary");
		openDetailsElement.removeAttribute("open");
		summaryElement.focus();
	}

	onFocusOut(e) {
		const withBoundaries = e.composedPath().includes(this.mainDetailsToggle);

		if (!withBoundaries) {
			this.mainDetailsToggle.removeAttribute("open");
		}
	}

	close() {
		this.mainDetailsToggle.removeAttribute("open");
	}
}

customElements.define("details-disclosure", DetailsDisclosure);
class DetailsDisclosureFilter extends HTMLElement {
	constructor() {
		super();
		this.mainDetailsToggle = this.querySelector("details");
		this.content = this.mainDetailsToggle?.querySelector(".close_filter_element");

		this.addEventListener("keyup", this.onKeyUp);
		this.content?.addEventListener("focusout", this.onFocusOut.bind(this));
		this.content?.addEventListener("click", (event) => {
			event.preventDefault();
			this.close();
		});
		this.mainDetailsToggle?.addEventListener("toggle", () => {
			if (!this.mainDetailsToggle.open) this.close();
		});
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;

		const openDetailsElement = event.target.closest("details[open]");
		if (!openDetailsElement) return;

		const summaryElement = openDetailsElement.querySelector("summary");
		this.close();
		summaryElement?.focus();
	}

	onFocusOut() {
		setTimeout(() => {
			this.close();
		});
	}

	close() {
		this.mainDetailsToggle?.removeAttribute("open");
		this.mainDetailsToggle?.querySelector("summary")?.setAttribute("aria-expanded", false);
		// Every close path must release the mask, including Close and keyboard focus.
		const container = this.closest("facet-filters-form") || this.parentElement;
		container?.querySelectorAll(".facets-mask, .facets__wrapper-js, .facets__wrapper, .facets__button-show")
			.forEach((element) => element.classList.remove("active"));
	}
}

customElements.define("details-disclosure-filter", DetailsDisclosureFilter);
